<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt1"><span class="hlink" href="#/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span class="hlink" href="#/cop" title="Link target outside of Sample">Copyright</span></p>
<p class="crt"><a class="hlink" href="#/ded">Dedication</a></p>
<p class="crt1"><a class="hlink" href="#/prologue">Prologue</a></p>
<p class="crt"><a class="hlink" href="#/c01">Chapter 1</a></p>
<p class="crt"><span class="hlink" href="#/c02" title="Link target outside of Sample">Chapter 2</span></p>
<p class="crt"><span class="hlink" href="#/c03" title="Link target outside of Sample">Chapter 3</span></p>
<p class="crt"><span class="hlink" href="#/c04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="crt"><span class="hlink" href="#/c05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="crt"><span class="hlink" href="#/c06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="crt"><span class="hlink" href="#/c07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="crt"><span class="hlink" href="#/c08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="crt1"><span class="hlink" href="#/ata" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="crt"><span class="hlink" href="#/ata" title="Link target outside of Sample">About the Author</span></p>
<p class="crt"><span class="hlink" href="#/alsoby" title="Link target outside of Sample">Also by Charlaine Harris</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6e6ab0ba